import { gql } from '@apollo/client'

export default gql(`
    mutation createBucketGroupType($name: String! $position: Int! $project: String ) {
        createBucketGroupType(
            input: {
                name: $name
                position: $position
            },
            project: $project
        ) {
            id
            name
            position
            usedCount
        }
    }`
)
